import { QuadraUpdateActionUnion, QuadraUpdateActionKeys } from './action';
import { IQuadraUpdateState } from './IQuadraUpdateState';

const initialState: IQuadraUpdateState = {
  data: {
    data: false,
    success: false
  },
  error: {
    data: [],
    success: false
  },
  isLoading: false
};

const quadraUpdateReducer = (state = initialState, action: QuadraUpdateActionUnion): IQuadraUpdateState => {
  switch (action.type) {
    case QuadraUpdateActionKeys.FETCH_QUADRA_UPDATE_STARTED:
      return {
        ...state,
        isLoading: true
      };
    case QuadraUpdateActionKeys.FETCH_QUADRA_UPDATE_SUCCEEDED:
      alert('Quadra atualizada com sucesso !! ');
      return {
        ...state,
        data: action.payload,
        isLoading: false
      };
    case QuadraUpdateActionKeys.FETCH_QUADRA_UPDATE_FAILED:
      alert('Não foi possivel atualizar a quadra!!!');
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    default:
      return state;
  }
};

export default quadraUpdateReducer;
